import {
	default as EChartsReact,
	default as ReactECharts,
} from "echarts-for-react";
import React, { Component } from "react";
import { COMPLETION_RATE } from "../../../api/types";
interface AppProp {
	value: Array<number>;
	month: Array<string>;
	onDownload: (urls: [string, string]) => void;
}
export class CompletionRate extends Component<AppProp, {}> {
	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([COMPLETION_RATE, base64]);
		}
	}

	getOption(rate: Array<number>, month: Array<string>): Object {
		return {
			title: {
				text: "Completion Rate",
			},
			tooltip: {
				trigger: "axis",
			},
			grid: {
				left: "3%",
				right: "4%",
				bottom: "3%",
				containLabel: true,
				height: "60%",
				width: "80%",
			},
			xAxis: {
				type: "category",
				data: month,
			},
			yAxis: {
				type: "value",
			},
			series: [
				{
					data: rate,
					type: "line",
					markPoint: {
						data: [
							{ type: "max", name: "Max" },
							{ type: "min", name: "Min" },
						],
					},
					markLine: {
						data: [{ type: "average", name: "Avg" }],
						label: {
							fontWeight: "bold",
							formatter: function (params: any) {
								// const str = "Average: " +  String(params.value);
								// return str
								// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
								return ` Average: ${params.value}
								`;
							},
						},
					},
				},
			],
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.value, this.props.month)}
			/>
		);
	}
}
